import { useMutation } from '@tanstack/react-query'
import { postData } from '../../apis/api.helpers'
import apiUrl from '../../apis/api.url'

// API call
const fetchResetPassword = async ({
  id,
  token,
  password,
  password_confirmation,
}: {
  id: string
  token: string
  password: string
  password_confirmation: string
}) => {
  const url = `${apiUrl.RESET_PASSWORD}`
  const response = await postData(url, {
    id,
    token,
    password,
    password_confirmation,
  })
  return response
}

export const useResetPassword = () => {
  return useMutation({
    mutationFn: ({
      id,
      token,
      password,
      password_confirmation,
    }: {
      id: string
      token: string
      password: string
      password_confirmation: string
    }) => fetchResetPassword({ id, token, password, password_confirmation }),
  })
}
